export default __webpack_public_path__ + "static/media/middle_flow_person.4173e27d.png";